import { lazy, useEffect } from 'react';
import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';
import { getCurrentUser } from 'services/Services';

const dashboards = {
  index: lazy(() => import('views/dashboards/Dashboards')),
  default: lazy(() => import('views/dashboards/DashboardsDefault')),
  // visual: lazy(() => import('views/dashboards/DashboardsVisual')),
  // analytic: lazy(() => import('views/dashboards/DashboardsAnalytic')),
  // test: lazy(() => import('views/dashboards/DashboardsTest')),
};

const functions = {
  index: lazy(() => import('views/function/Functions')),
  recruitment: {
    index: lazy(() => import('views/function/recruitment/Recruitment')),
    // jobRequisitionRequestForm: lazy(() => import('views/function/recruitment/job-requisition-request-form/JobRequisitionRequestForm')),
    jobOnBoardingChecklistRecord: lazy(() => import('views/function/recruitment/job-on-boarding-checklist/JobOnBoardingChecklistRecord')),
    idCardPrintingRequestForm: lazy(() => import('views/function/recruitment/id-card-printing-request/IdCardPrinting')),
  },
  attendance: {
    index: lazy(() => import('views/function/attendance/Attendance')),
    tardinessRequestForm: lazy(() => import('views/function/attendance/tardiness-request-form/TardinessRequestForm')),
    changeDayoffRequestForm: lazy(() => import('views/function/attendance/change-dayoff-request-form/ChangeDayoffRequestForm')),
    changeTimesheetsRequestForm: lazy(() => import('views/function/attendance/change-timesheets-request-form/ChangeTimesheetsRequestForm')),
    overtimeRequestForm: lazy(() => import('views/function/attendance/overtime-request-form/OvertimeRequestForm')),
    leaveRequestForm: lazy(() => import('views/function/attendance/leave-request-form/LeaveRequestForm')),
    attendanceHistoryRecord: lazy(() => import('views/function/attendance/attendance-history-record/AttendanceHistoryRecord')),
    overtimeHistoryRecord: lazy(() => import('views/function/attendance/overtime-history-record/OvertimeHistoryRecord')),
    employeeLeaveEntitlementRecord: lazy(() => import('views/function/attendance/employee-leave-entitlement-record/EmployeeLeaveEntitlementRecord')),
    substitutionRequestForm: lazy(() => import('views/function/attendance/substitution-request-form/SubstitutionRequestForm')),
    // dailyClockTimeReport: lazy(() => import('views/function/attendance/daily-clock-time-report/DailyClockTimeReport')),
    // dailyTimesheetMatchingReport: lazy(() => import('views/function/attendance/daily-timesheet-matching-report/DailyTimesheetMatchingReport')),
    // dailySummaryWorkingHourReport: lazy(() => import('views/function/attendance/daily-summary-working-hour-report/DailySummaryWorkingHourReport')),
    // dailyAttendanceKpiReport: lazy(() => import('views/function/attendance/daily-attendance-kpi-report/DailyAttendanceKpiReport')),
    // dailyOvertimeSummaryReport: lazy(() => import('views/function/attendance/daily-overtime-summary-report/DailyOvertimeSummaryReport')),
    // monthlyAttendanceKpiReport: lazy(() => import('views/function/attendance/monthly-attendance-kpi-report/MonthlyAttendanceKpiReport')),
  },
  career: {
    index: lazy(() => import('views/function/career/Career')),
    staffInformationRecord: lazy(() => import('views/function/career/staff-information-record/StaffInformationRecord')),
    jobOffBoardingChecklist: lazy(() => import('views/function/career/job-off-boarding-checklist/JobOffBoardingChecklist')),
    personalInformationChangeRequestForm: lazy(() =>
      import('views/function/career/personal-information-change-request-form/PersonalInformationChangeRequestForm')
    ),
    scholarshipRequestForm: lazy(() => import('views/function/career/scholarship-request-form/ScholarshipRequestForm')),
    endProbationRequestForm: lazy(() => import('views/function/career/end-probation-request-form/EndProbationRequestForm')),
    careerChangeRequestForm: lazy(() => import('views/function/career/career-change-request-form/CareerChangeRequestForm')),
    resignationRequestForm: lazy(() => import('views/function/performance/resignation-request-form/ResignationRequestForm')),
    employmentCertificateRequestForm: lazy(() => import('views/function/performance/employment-certificate-request-form/EmploymentCertificateRequestForm')),
    salaryCertificateRequestForm: lazy(() => import('views/function/career/salary-certificate-request-form/SalaryCertificateRequestForm')),
    myTaskActivity: lazy(() => import('views/function/career/my-task-activity/MyTaskActivity')),
    // approvalDocument: lazy(() => import('views/function/career/approval-document/ApprovalDocument')),
    // myRequestApproval: lazy(() => import('views/function/career/my-request-approval/MyRequestApproval')),
  },
  training: {
    index: lazy(() => import('views/function/training/Training')),
    internalTrainingRequestForm: lazy(() => import('views/function/training/internal-training-request-form/InternalTraining')),
    externalTrainingRequestForm: lazy(() => import('views/function/training/external-training-request-form/ExternalTrainingRequestForm')),
    trainingTopicAssessmentTestForm: lazy(() => import('views/function/training/training-topic-assessment-test/TrainingTopicAssessmentTest')),
    assessmentOfTrainingSurveyForm: lazy(() => import('views/function/training/assessment-of-training-survey/AsessmentOfTrainingSurvey')),
    hrInductionAssessmentTestForm: lazy(() => import('views/function/training/hr-induction-assessment-test/HrInductionAssessmentTest')),
    hrInductionAssessmentTestEmployeeForm: lazy(() =>
      import('views/function/training/hr-induction-assessment-test-employee/HrInductionAssessmentTestEmployee')
    ),
    trainingHistoryForm: lazy(() => import('views/function/training/training-history/TrainingHistory')),
    trainingCalender: lazy(() => import('views/function/training/training-calender/TrainingCalender')),
    externalTrainingReport: lazy(() => import('views/function/training/external-training-report/ExternalTrainingReport')),
    externalScholarshipRequest: lazy(() => import('views/function/training/external-education-scholarship/ExternalEducationScholarship')),
    trainingNeedsAssessment: lazy(() => import('views/function/training/training-needs-assessment/TrainingNeedsAssessment')),
    trainingCalendarRegistration: lazy(() => import('views/function/training/training-calendar-registration/TrainingCalendarRegistration')),
  },

  performance: {
    index: lazy(() => import('views/function/performance/Performance')),
    incidentRecord: lazy(() => import('views/function/performance/incident-record/IncidentRecord')),
    disciplinaryForm: lazy(() => import('views/function/performance/disciplinary-request-form/DisciplinaryForm')),
    appraisalRequestForm: lazy(() => import('views/function/performance/appraisal-request-form/AppraisalRequestForm')),
    jobHandoverRequestForm: lazy(() => import('views/function/performance/job-handover-request-form/JobHandoverRequestForm')),
    employeeExitClearanceForm: lazy(() => import('views/function/performance/employee-exit-clearance-form/EmployeeExitClearanceForm')),
    employeeSatisfactionForm: lazy(() => import('views/function/performance/employee-satisfaction-survey/EmployeeSatifactionSurvey')),
    employeeExitInterviewForm: lazy(() => import('views/function/performance/employee-exit-interview/EmployeeExitInterview')),
    terminationForm: lazy(() => import('views/function/performance/employee-termination-request-form/TerminationForm')),
    employeeSuspendLeaveRequestForm: lazy(() => import('views/function/attendance/employee-subspend-leave-request-form/EmployeeSubspendLeave')),
    employeeEndProbation: lazy(() => import('views/function/performance/employee-end-probation-form/EmployeeEndProbation')),
    employeeEngagementSurvey: lazy(() => import('views/function/performance/employee-engagement-survey/EmployeeEngagementSurvey')),
  },
  payroll: {
    index: lazy(() => import('views/function/payroll/Payroll')),
    payrollHistoryRecord: lazy(() => import('views/function/payroll/payroll-history-record/PayrollHistoryRecord')),
  },
};

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

export default function routesAndMenuItems() {
  const employee = getCurrentUser(); // <— your requirement

  const tmpRoutesAndMenuItems = {
    mainMenuItems: [
      {
        path: DEFAULT_PATHS.APP,
        exact: true,
        redirect: true,
        to: `${appRoot}/login`,
      },
      {
        path: DEFAULT_PATHS.RESET_PASSWORD,
        exact: true,
        redirect: true,
        to: `${appRoot}/change-password`,
      },
      {
        path: DEFAULT_PATHS.EMPLOYEE_PROFILE,
        exact: true,
        redirect: true,
        roles: [USER_ROLE.Admin, USER_ROLE.Editor],
        to: `${appRoot}/employee-profile`,
      },
      {
        path: DEFAULT_PATHS.EMPLOYEE_ANNOUNCEMENT,
        exact: true,
        redirect: true,
        roles: [USER_ROLE.Admin, USER_ROLE.Editor],
      },
      {
        path: `${appRoot}/dashboards`,
        component: dashboards.index,
        label: 'Dashboards',
        icon: 'home',
        roles: [USER_ROLE.Admin, USER_ROLE.Editor],
        subs: [
          { path: '/default', label: 'Home', component: dashboards.default },
          // { path: '/visual', label: 'menu.visual', component: dashboards.visual },
          // { path: '/analytic', label: 'menu.analytic', component: dashboards.analytic },
          // { path: '/test/:id', component: dashboards.test },
        ],
      },
      {
        path: `${appRoot}/functions`,
        label: 'Functions',
        icon: 'pocket-knife',
        component: functions.index,
        roles: [USER_ROLE.Admin, USER_ROLE.Editor],
        mega: true,
        subs: [
          // Recruitment
          {
            path: '/recruitment',
            label: 'Recruitment',
            component: functions.recruitment.index,
            subs: [
              // { path: '/job-requisition-request-form', label: 'Job Requisition Request Form', component: functions.recruitment.jobRequisitionRequestForm },
              ...(employee?.ess_new_job_onboarding_task === 'Yes'
                ? [
                  {
                    path: '/job-onboarding-task',
                    label: 'New Job Onboarding Checklist',
                    component: functions.recruitment.jobOnBoardingChecklistRecord,
                  },
                ]
                : []),
              ...(employee?.ess_id_card_printing_request === 'Yes'
                ? [
                  {
                    path: '/id-card-printing-request',
                    label: 'ID Card Printing Request',
                    component: functions.recruitment.idCardPrintingRequestForm,
                  },
                ]
                : []),
            ],
          },

          // Attendance
          {
            path: '/attendance',
            label: 'Attendance',
            component: functions.attendance.index,
            subs: [
              ...(employee?.ess_tardiness_form === 'Yes'
                ? [{ path: '/tardiness-request-form', label: 'Tardiness Request Form', component: functions.attendance.tardinessRequestForm }]
                : []),
              ...(employee?.ess_change_dayoff_form === 'Yes'
                ? [{ path: '/change-dayoff-request-form', label: 'Change Dayoff Request Form', component: functions.attendance.changeDayoffRequestForm }]
                : []),
              ...(employee?.ess_change_timesheet_form === 'Yes'
                ? [{ path: '/change-timesheets-request-form', label: 'Change Shift Request Form', component: functions.attendance.changeTimesheetsRequestForm }]
                : []),
              ...(employee?.ess_overtime_form === 'Yes'
                ? [{ path: '/overtime-request-form', label: 'Overtime Request Form', component: functions.attendance.overtimeRequestForm }]
                : []),
              ...(employee?.ess_leave_form === 'Yes'
                ? [{ path: '/leave-request-form', label: 'Leave Request Form', component: functions.attendance.leaveRequestForm }]
                : []),
              ...(employee?.ess_attendance_history === 'Yes'
                ? [{ path: '/attendance-history-record', label: 'Attendance History Record', component: functions.attendance.attendanceHistoryRecord }]
                : []),
              ...(employee?.ess_overtime_history === 'Yes'
                ? [{ path: '/overtime-history-record', label: 'Overtime History Record', component: functions.attendance.overtimeHistoryRecord }]
                : []),
              ...(employee?.ess_leave_entitlement_history === 'Yes'
                ? [
                  {
                    path: '/employee-leave-entitlement-record',
                    label: 'Employee Leave Entitlement Record',
                    component: functions.attendance.employeeLeaveEntitlementRecord,
                  },
                ]
                : []),
              ...(employee?.ess_web_substitution_form === 'Yes'
                ? [
                  {
                    path: '/substitution-request-form',
                    label: 'Substitution Request Form',
                    component: functions.attendance.substitutionRequestForm,
                  },
                ]
                : []),
            ],
          },

          // Personal Management
          {
            path: '/career',
            label: 'Personal Management',
            component: functions.career.index,
            subs: [
              ...(employee?.ess_staff_information === 'Yes'
                ? [{ path: '/staff-information-record', label: 'Staff Information Record', component: functions.career.staffInformationRecord }]
                : []),
              ...(employee?.ess_personal_change_form === 'Yes'
                ? [
                  {
                    path: '/personal-information-change-request-form',
                    label: 'Personal Info. Change Request Form',
                    component: functions.career.personalInformationChangeRequestForm,
                  },
                ]
                : []),
              ...(employee?.ess_scholarship_form === 'Yes'
                ? [{ path: '/scholarship-request-form', label: 'Scholarship Request Form', component: functions.career.scholarshipRequestForm }]
                : []),
              ...(employee?.ess_new_job_onboarding_task === 'Yes'
                ? [{ path: '/my-activity-tasks', label: 'My Task Activity', component: functions.career.myTaskActivity }]
                : []),

              // { path: '/my-approval-document', label: 'My Approval Document', component: functions.career.approvalDocument },
              // { path: '/my-request-approval-document', label: 'My Request Approval', component: functions.career.myRequestApproval },
              ...(employee?.ess_payroll_history === 'Yes'
                ? [{ path: '/payroll-history-record', label: 'Payroll History Record', component: functions.payroll.payrollHistoryRecord }]
                : []),
              ...(employee?.ess_salary_certificate_form === 'Yes'
                ? [
                  {
                    path: '/salary-certificate-request-form',
                    label: 'Salary Certificate Request Form',
                    component: functions.career.salaryCertificateRequestForm,
                  },
                ]
                : []),
            ],
          },

          // Training & Development
          {
            path: '/training',
            label: 'Training & Development',
            component: functions.training.index,
            roles: [USER_ROLE.Admin, USER_ROLE.Editor],
            subs: [
              // ...(employee?.ess_training_internal === 'Yes'
              //   ? [
              //       {
              //         path: '/employee-training-plan-request-form',
              //         label: 'Internal Training Request Form',
              //         component: functions.training.internalTrainingRequestForm,
              //       },
              //     ]
              //   : []),
              ...(employee?.ess_training_external === 'Yes'
                ? [
                  {
                    path: '/external-training-request-form',
                    label: 'External Training Request Form',
                    component: functions.training.externalTrainingRequestForm,
                  },
                ]
                : []),
              // { path: '/training-topic-test', label: 'Training Topic Test Assessment Test', component: functions.training.trainingTopicAssessmentTestForm },
              // { path: '/hr-induction-assessment-test', label: 'HR Induction Assessment Test (C)', component: functions.training.hrInductionAssessmentTestForm },
              // {
              //   path: '/hr-induction-assessment-test-employee',
              //   label: 'HR Induction Assessment Test (E)',
              //   component: functions.training.hrInductionAssessmentTestEmployeeForm,
              // },
              // { path: '/training-questionnaires', label: 'Assessment Of Training Survey', component: functions.training.assessmentOfTrainingSurveyForm },
              // { path: '/employee-training-history', label: 'Training History Record', component: functions.training.trainingHistoryForm },
              ...(employee?.ess_training_calendar === 'Yes'
                ? [{ path: '/training-calendar', label: 'Training Calendar', component: functions.training.trainingCalender }]
                : []),
              ...(employee?.ess_external_training_report === 'Yes'
                ? [{ path: '/external-training-report', label: 'External Training Report', component: functions.training.externalTrainingReport }]
                : []),
              ...(employee?.ess_sponsored_external_training_form === 'Yes'
                ? [
                  {
                    path: '/external-education-scholarship-request-form',
                    label: 'Degree Sponsorship Request Form',
                    component: functions.training.externalScholarshipRequest,
                  },
                ]
                : []),
              ...(employee?.ess_training_needs_assessment === 'Yes'
                ? [
                  {
                    path: '/training-needs-assessment',
                    label: 'Training Needs Assessment',
                    component: functions.training.trainingNeedsAssessment,
                  },
                ]
                : []),
              ...(employee?.ess_training_calendar_registration === 'Yes'
                ? [
                  {
                    path: '/training-calendar-registration',
                    label: 'Employee Training Registration',
                    component: functions.training.trainingCalendarRegistration,
                  },
                ]
                : []),
            ],
          },

          // Performance
          {
            path: '/performance',
            label: 'Performance',
            component: functions.performance.index,
            roles: [USER_ROLE.Admin, USER_ROLE.Editor],
            subs: [
              ...(employee?.ess_employment_certificate_form === 'Yes'
                ? [
                  {
                    path: '/employment-certificate-request-from',
                    label: 'Employment Certificate Request',
                    component: functions.career.employmentCertificateRequestForm,
                  },
                ]
                : []),
              ...(employee?.ess_incident_form === 'Yes'
                ? [{ path: '/incident-record', label: 'Incident Report', component: functions.performance.incidentRecord }]
                : []),
              ...(employee?.ess_disciplinary_form === 'Yes'
                ? [{ path: '/employee-disciplinary-request-form', label: 'Disciplinary Action Request', component: functions.performance.disciplinaryForm }]
                : []),
              ...(employee?.ess_appraisal_form === 'Yes'
                ? [{ path: '/appraisal-request-form', label: 'Performance Appraisal Request', component: functions.performance.appraisalRequestForm }]
                : []),
              ...(employee?.ess_resignation_form === 'Yes'
                ? [{ path: '/resignation-request-from', label: 'Resignation Request', component: functions.career.resignationRequestForm }]
                : []),
              ...(employee?.ess_exit_clearance_form === 'Yes'
                ? [{ path: '/employee-cessation-form', label: 'Employee Exit Clearance', component: functions.performance.employeeExitClearanceForm }]
                : []),
              ...(employee?.ess_exit_interview_form === 'Yes'
                ? [{ path: '/employee-exit-interview-form', label: 'Employee Exit Interview', component: functions.performance.employeeExitInterviewForm }]
                : []),
              ...(employee?.ess_job_handover_form === 'Yes'
                ? [{ path: '/job-handover-request-form', label: 'Job Handover Form', component: functions.performance.jobHandoverRequestForm }]
                : []),
              ...(employee?.ess_employee_satisfaction_form === 'Yes'
                ? [
                  {
                    path: '/employee-satisfaction-form',
                    label: 'Employee Feedback Survey',
                    component: functions.performance.employeeSatisfactionForm,
                  },
                ]
                : []),
              ...(employee?.ess_employee_termination_request_form === 'Yes'
                ? [
                  {
                    path: '/employee-termination-request-form',
                    label: 'Termination Request',
                    component: functions.performance.terminationForm,
                  },
                ]
                : []),
              ...(employee?.ess_employee_subspend_leave_request_form === 'Yes'
                ? [
                  {
                    path: '/employee-suspend-leave-request-form',
                    label: 'Suspended Leave Request',
                    component: functions.performance.employeeSuspendLeaveRequestForm,
                  },
                ]
                : []),
              ...(employee?.ess_employee_end_probation_form === 'Yes'
                ? [
                  {
                    path: '/employee-end-probation-form',
                    label: 'Confirmed and Unsuccessful Probation',
                    component: functions.performance.employeeEndProbation,
                  },
                ]
                : []),
              ...(employee?.ess_employee_engagement_survey === 'Yes'
                ? [
                  {
                    path: '/employee-engagement-survey',
                    label: 'Employee Engagement Survey',
                    component: functions.performance.employeeEngagementSurvey,
                  },
                ]
                : []),
            ],
          },
        ],
      },
    ],
    sidebarItems: [
      { path: '#connections', label: 'menu.connections', icon: 'diagram-1', hideInRoute: true },
      { path: '#bookmarks', label: 'menu.bookmarks', icon: 'bookmark', hideInRoute: true },
      { path: '#requests', label: 'menu.requests', icon: 'diagram-2', hideInRoute: true },
      {
        path: '#account',
        label: 'menu.account',
        icon: 'user',
        hideInRoute: true,
        subs: [
          { path: '/settings', label: 'menu.settings', icon: 'gear', hideInRoute: true },
          { path: '/password', label: 'menu.password', icon: 'lock-off', hideInRoute: true },
          { path: '/devices', label: 'menu.devices', icon: 'mobile', hideInRoute: true },
        ],
      },
      {
        path: '#notifications',
        label: 'menu.notifications',
        icon: 'notification',
        hideInRoute: true,
        subs: [
          { path: '/email', label: 'menu.email', icon: 'email', hideInRoute: true },
          { path: '/sms', label: 'menu.sms', icon: 'message', hideInRoute: true },
        ],
      },
      {
        path: '#downloads',
        label: 'menu.downloads',
        icon: 'download',
        hideInRoute: true,
        subs: [
          { path: '/documents', label: 'menu.documents', icon: 'file-text', hideInRoute: true },
          { path: '/images', label: 'menu.images', icon: 'file-image', hideInRoute: true },
          { path: '/videos', label: 'menu.videos', icon: 'file-video', hideInRoute: true },
        ],
      },
    ],
  };

  return tmpRoutesAndMenuItems;
}
